import { makeStyles } from "@material-ui/core/styles";
import CheckinBgImg from "Assets/images/checkin-bg.svg";

export const useStyles = makeStyles((theme) => ({
  leftSection: {
    "& .MuiCard-root": {
      height: "100%",
    },
    [theme.breakpoints.up("xs")]: {
      width: 290,
    },
    "& .MuiAvatar-root": {
      marginRight: 0,
    },
    "& .frequency-field": {
      "& .MuiInputLabel-formControl": {
        margin: 0,
      },
    },
  },
  primaryCoachWrapper: {
    border: "2px solid #BCC9D6",
    padding: 2,
    borderRadius: "50%",
  },
  checkinType: {
    "& h6": {
      display: "flex",
      alignItems: "center",
    },
    "& .overdue": {
      background: "#FFE6E6",
      color: "#C41313",
    },
    "& .complete": {
      background: "#D5F9E3",
      color: "#0A652B",
    },
    "& .planned": {
      background: "#D1F8F2",
      color: "#138D7D",
    },
    "& .inprogress": {
      background: "#D8DFFF",
      color: "#4B5884",
    },
  },
  checkinStatus: {
    padding: "4px 24px",
    height: 23,
    borderRadius: 25,
    fontSize: 13,
    fontWeight: 500,
    lineHeight: "14px",
    // textTransform: "capitalize",
  },
  formattedText: {
    "& p": {
      marginTop: 0,
      lineHeight: "18px",
    },
    "& *": {
      background: "none !important",
      color: "inherit !important",
      fontSize: "13px !important",
      fontFamily: "inherit !important",
    },
  },
  textSize: {
    fontSize: 12,
  },
  userName: {
    "& span": {
      width: 60,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "block",
      lineHeight: "14px",
    },
  },
  deactivateUser: {
    "& span": {
      width: 60,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "block",
      lineHeight: "14px",
      opacity: 0.5,
    },
  },
  media: {
    "& .multimedia-box": {
      "& .img-preview": {
        height: 130,
        width: "100%",
        objectFit: "cover",
      },
      "& .thumbnails": {
        height: 130,
        background: `url(${CheckinBgImg}) no-repeat`,
        backgroundPosition: "center",
        backgroundSize: "contain",
      },
    },
    "& a": {
      color: theme.palette.primary.main,
      textDecoration: "none",
    },
    "& .file-wrapper": {
      flexWrap: "wrap",
      display: "flex",
    },
    "& .attachment-label": {
      fontSize: 13,
      margin: 0,
    },
    "& .added-attachment": {
      "&:hover": {
        boxShadow: "0px 1px 4px #0000001A",
      },
    },
  },
  starIcon: {
    position: "absolute",
    width: 18,
    color: "#BCC9D6",
    bottom: 0,
    left: -2,
  },
  shortContent: {
    position: "relative",
    "&:after": {
      height: 15,
      background: "rgb(255 255 255 / 62%)",
      width: "100%",
      content: '""',
      position: "absolute",
      bottom: 0,
      left: 0,
    },
  },
}));
